// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1646) return "static/chunks/1646.314724838722bc18.js";
	if (chunkId === 5139) return "static/chunks/5139.3af505ae0c727fe9.js";
	if (chunkId === 2948) return "static/chunks/2948.280173546d9a3409.js";
	if (chunkId === 4358) return "static/chunks/4358.62f4c99b653f36e2.js";
	if (chunkId === 4209) return "static/chunks/4209.82c2f122a7fecdc5.js";
	if (chunkId === 8249) return "static/chunks/8249.140aa3ab4ae36da4.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "-" + {"506":"bd91c1ec6dd2e415","1153":"5138c15cb086d968","1551":"2707cfa579b2ca26","1761":"793cdd9afae8b550","3753":"be839477fc47d493","7628":"75a4a92c9a5c8179","8719":"c1fbfd9ea55a4bfc"}[chunkId] + ".js";
};